module.exports = __webpack_public_path__ + "static/media/awfxex32_113.47e4ca0e.ico";